export const formStyles = {
                  container : `  
                          font-family: 'Raleway';
                          width:100%;
                              `,
                  card: `
                          margin-bottom:3px;
                          padding: 15px;
                          font-size: 16px;
                          width: 100%;
                          border-radius: 3px;
                          border: 1px solid #dcdcdc;
                          -webkit-box-sizing: border-box;
                          box-sizing: border-box;
                          font-family: 'Raleway';
                          transition: 'border-color 0.2s ease-in-out';
                          card:focus: 'border-color: '#007bff',
                          `,
                  labels : `
                           font-family: 'Raleway'
                           white-space : 'nowrap'
                           font-size: '9px'
                           font-weight: bold
                            `,
                  
                  floatingLabelsPlaceholder : `
                           white-space : 'nowrap'
                           width:100%;
                           font-size:10px;
                            `,
                                 
                //   labelType : 'floating',
                  expiryContainer: `
                    width :100%
                  `,
                  expiryMonth: `
                                margin-top: 3px;
                                margin-bottom: 50px;
                                padding: 15px;
                                font-size: 16px;
                                width: 25%;
                                border-radius: 3px;
                                border: 1px solid #dcdcdc;
                                -webkit-box-sizing: border-box;
                                box-sizing: border-box;
                                font-family: 'Raleway';
                                `,
                  expirySeparator : `height :50px`,
                  expiryYear:  `
                              margin-top: 3px;
                              margin-bottom: 50px;
                              padding: 15px;
                              font-size: 16px;
                              width: 25%;
                              border-radius: 3px;
                              border: 1px solid #dcdcdc;
                              -webkit-box-sizing: border-box;
                              box-sizing: border-box;
                              font-family: 'Raleway';
                              ` ,

                  cvv2 :  `
                          margin-top: 3px;
                          margin-bottom: 50px;
                          padding: 15px;
                          font-size: 16px;
                          min-width: 40%;
                          border-radius: 3px;
                          border: 1px solid #dcdcdc;
                          -webkit-box-sizing: border-box;
                          box-sizing: border-box;
                          font-family: 'Raleway';
                           ` ,  
                error :  `
                         color: red;
                         margin-top:5px;  
                        `
}